import { type } from 'arktype';
import { createPaginatedResponseSchema } from '../shared/pagination';
import { connectionTypeSchema } from '../users';

/** Contrato de `userConnection`: conexión dirigida entre dos personas (documento 02a, §5.4). */
export const userConnectionResponseSchema = type({
	createdAt: 'string.date.iso',
	id: 'string.uuid',
	targetUserId: 'string.uuid',
	type: connectionTypeSchema,
	userId: 'string.uuid',
}).onUndeclaredKey('delete');

export type UserConnectionResponse = typeof userConnectionResponseSchema.infer;

/**
 * `POST /user-connections` (§6.2 y §7.2 del documento 02a): sin `userId` a propósito — el
 * servidor lo toma siempre del token, nunca del cuerpo, para que nadie pueda crear una
 * conexión (ni mucho menos un bloqueo) en nombre de otra persona.
 */
export const createUserConnectionSchema = type({
	targetUserId: 'string.uuid',
	type: connectionTypeSchema,
}).onUndeclaredKey('delete');

export type CreateUserConnection = typeof createUserConnectionSchema.infer;

// No hay `updateUserConnectionSchema`: una conexión se crea o se borra (§6.2), no se edita.

export const userConnectionPaginatedResponseSchema = createPaginatedResponseSchema(userConnectionResponseSchema);

export type UserConnectionPaginatedResponse = typeof userConnectionPaginatedResponseSchema.infer;
